import React from 'react'
import * as Component from './ResultInfoText.styles'
import { useSelector } from 'react-redux'
import DOMPurify from 'dompurify'

/**
 * Info Text Component encapsulating the information about the result list
 */
const ResultInfoText = () => {
  const state = useSelector((state) => state)
  const { radius, location, query } = state.search.prevParams
  const { count } = state.search

  const getRadiusText = () => {
    if (location !== undefined && location !== '' && radius !== 0) {
      return typeof radius === 'number'
        ? ` im Umkreis von ${ radius / 1000 } km um `
        : ` in `
    }
    return ' bundesweit'
  }

  return (
    <Component.Root>
      <span
        id='result-info-count'
        data-cy='result-info-count'
        data-cy-results={ count }>
        {count} Ergebnis{count !== 1 && 'se'}
      </span>
      {query && (
        <>
          &nbsp;für{' '}
          <Component.TextHighlight
            id='result-info-term'
            data-cy='result-info-term'
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(query) }}
          />
        </>
      )}

      <span id='result-info-radius' data-cy='result-info-radius'>
        {getRadiusText()}
      </span>

      {location && radius !== 0 && (
        <span id='result-info-location' data-cy='result-info-location'>
          <Component.TextHighlight>{location}</Component.TextHighlight>
        </span>
      )}
    </Component.Root>
  )
}

export default ResultInfoText
